exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".depend-on-section[data-v-11d2a2da] {\n  border-radius: 4px;\n}\n.sync-depend-radio-button .custom-control[data-v-11d2a2da] {\n  display: block !important;\n}\n", ""]);

// exports
